import React, { PureComponent, useEffect } from 'react'
import _ from 'lodash'
import { ApolloProvider } from 'react-apollo'
import {
  Router, Route, Switch, withRouter,
} from 'react-router-dom'
import TagManager from 'react-gtm-module'
import client from './apollo-client'
import history from './history'
import NotFound from './pages/not-found-page'
import Login from './pages/login'
import Home from './pages/home'
import SocialLogin from './pages/social-login'
import QuotationRequest from './pages/quotation-request'
import PaymentVerification from './pages/payment-verification-page'
import PrintingInformation from './pages/printing-information'
import Paper from './pages/printing-information/paper'
import PrintingTechnique from './pages/printing-information/printing-technique'
import Member from './pages/member'
import Register from './pages/register'
import ForgetPassword from './pages/forget-password'
import ResetPassword from './pages/forget-password/new-password'
import ActivePage from './pages/activate'
import GalleryContainer from './pages/gallery'
import PackagingList from './pages/package-page/list'
import PackagingDetail from './pages/package-page/detail'
import PATH from './constants/path'
import { getAccessToken } from './utils/local-data-service'

let isVisitedHome = false

class ScrollToTopRouteClass extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      showModal: !_.isUndefined(props.showModal) ? props.showModal : false,
    }
  }

  checkIsHome = (path) => {
    if (path === PATH.home) {
      this.setState({ showModal: this.props.showModal }, () => {
        isVisitedHome = true
      })
    }
  }

  componentDidMount() {
    this.checkIsHome(this.props.path)
  }

  componentDidUpdate(prevProps) {
    if (this.props.path === this.props.location.pathname && this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0)
    }
    if (!isVisitedHome) {
      this.checkIsHome(this.props.path)
    } else {
      this.setState({ showModal: false })
    }
  }

  render() {
    const { component: Component, ...rest } = this.props
    return <Route {...rest} render={props => (<Component showModal={this.state.showModal} {...props} />)} />
  }
}

const ScrollToTopRoute = withRouter(ScrollToTopRouteClass)

const App = () => {
  useEffect(() => {
    TagManager.initialize({ gtmId: 'GTM-56B3LC2' })
  }, [])
  return (
    <ApolloProvider client={client}>
      <Router history={history}>
        <Switch>
          <Route path={PATH.login} exact component={Login} />
          <ScrollToTopRoute path={PATH.home} home showModal exact component={Home} />
          <ScrollToTopRoute path={PATH.socialLogin} exact component={SocialLogin} />
          <ScrollToTopRoute path={PATH.request} exact component={QuotationRequest} />
          <ScrollToTopRoute path={PATH.payment} exact component={PaymentVerification} />
          <ScrollToTopRoute path={PATH.information} exact component={PrintingInformation} />
          <ScrollToTopRoute path={PATH.paper} exact component={Paper} />
          <ScrollToTopRoute path={PATH.printingTechnique} exact component={PrintingTechnique} />
          <ScrollToTopRoute path={PATH.member} exact component={!getAccessToken() ? () => { window.location = PATH.home } : Member} />
          <ScrollToTopRoute path={PATH.register} exact component={Register} />
          <ScrollToTopRoute path={PATH.forgetPassword} exact component={ForgetPassword} />
          <ScrollToTopRoute path={PATH.resetPassword} exact component={ResetPassword} />
          <ScrollToTopRoute path={PATH.activate} exact component={ActivePage} />
          <ScrollToTopRoute path={PATH.gallery} exact component={GalleryContainer} />
          <ScrollToTopRoute path={PATH.packaging} exact component={PackagingList} />
          <ScrollToTopRoute path={`${PATH.packagingDetail}/:id`} component={PackagingDetail} />
          <ScrollToTopRoute component={NotFound}/>
        </Switch>
      </Router>
    </ApolloProvider>
  )
}

export default App



// WEBPACK FOOTER //
// ./src/app.js